/**
 * 全局自定义指令注册
 * @description 统一管理和注册项目中的 Vue 自定义指令
 */
import type { App } from 'vue'
import { vImgFallback } from './vImgFallback'

/**
 * 注册所有全局自定义指令
 */
export function setupDirectives(app: App): void {
  app.directive('img-fallback', vImgFallback)
}

export { vImgFallback }
